const exportKey = {
    invoice: {
        tracker: "export:job:faktur_transaksi_masal:invoice",
        job: "invoice_transaksi_masal",
    },
    lampiran: {
        tracker: "export:job:faktur_transaksi_masal:lampiran",
        job: "lampiran_transaksi_masal",
    },
};

export default exportKey;
